import { render, staticRenderFns } from "./productdetail.vue?vue&type=template&id=feec592a&scoped=true"
import script from "./productdetail.vue?vue&type=script&lang=js"
export * from "./productdetail.vue?vue&type=script&lang=js"
import style0 from "./productdetail.vue?vue&type=style&index=0&id=feec592a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feec592a",
  null
  
)

export default component.exports